import {
  Component,
  HostListener,
  inject,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import {
  faArrowRightFromBracket,
  faChevronDown,
  faHeadphonesAlt,
} from '@fortawesome/free-solid-svg-icons';
import { filter, take } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth';
import { LoaderService } from 'src/app/core/services/loader';
import { ScreenService } from 'src/app/core/services/screen';
import {
  MenuChild,
  MenuItem,
  SharedService,
} from 'src/app/core/services/shared';
import { SidenavMenuItemComponent } from '../sidenav-menu-item';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  @ViewChild('navContainer')
  navContainer!: MatSidenavContainer;

  @ViewChildren(SidenavMenuItemComponent)
  sidenavMenuItems?: SidenavMenuItemComponent[];

  router = inject(Router);
  loader = inject(LoaderService);
  authService = inject(AuthService);
  screenService = inject(ScreenService);
  sharedService = inject(SharedService);
  appName = this.sharedService.GetAppName();
  isSidenavOpened$ = this.sharedService.isSidenavOpened$;

  isAuthenticated$ = this.authService.isAuthenticated$;

  isSmallWidth$ = this.screenService.isSmallWidth$;

  empresaSelecionada$ = this.authService.empresaSelecionada$;

  activatedItem: MenuItem | null = null;

  menuItems$ = this.sharedService.menuItems$;

  usuario$ = this.authService.usuario$;

  faChevronDown = faChevronDown;
  faArrowRightFromBracket = faArrowRightFromBracket;
  faHeadphonesAlt = faHeadphonesAlt;

  @HostListener('click', ['$event.target'])
  onClick(element: HTMLElement) {
    const hasBackdropClass = element.classList.contains('mat-drawer-backdrop');

    if (hasBackdropClass) {
      this.sharedService.toggleSidenav();
    }
  }

  toggleSidenav(): void {
    this.sharedService.toggleSidenav();
  }

  toggleActivatedMenu(item: MenuItem): void {
    item.onClick?.();

    if (!item.children) {
      this.closeSidenavIfSmallScreen();
    }

    if (this.activatedItem === item) {
      this.activatedItem = null;
      return;
    }

    this.activatedItem = item;
  }

  clearActivatedMenu(): void {
    this.activatedItem = null;

    this.closeSidenavIfSmallScreen();
  }

  onMenuItemOpened(child: MenuChild): void {
    this.sidenavMenuItems
      ?.filter((menuItem) => menuItem.item !== child)
      .forEach((child) => child.clearActivatedChild());
  }

  closeSidenavIfSmallScreen(): void {
    this.isSmallWidth$.pipe(take(1), filter(Boolean)).subscribe(() => {
      this.sharedService.toggleSidenav();
    });
  }

  signOut(): void {
    const loaderRef = this.loader.open('Saindo...');
    this.authService
      .signOut()
      .subscribe(() => {
        this.router.navigate(['autenticacao', 'entrar']);
      })
      .add(() => loaderRef.close());
  }
}
